import { createNoopInjectionToken } from 'ngxtension/create-injection-token';

export const [injectAppleRedirectUri, provideAppleRedirectUri] =
  createNoopInjectionToken<string>('Apple Redirect Uri');
